var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccomplishment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H9V20H2C0.89 20 0 19.11 0 18V2C0 0.9 0.89 0 2 0H14C15.11 0 16 0.9 16 2V10.54L14.5 9.72L14 10V2H9V10L6.5 7.75L4 10V2H2V18ZM20 15L14.5 12L9 15L14.5 18L20 15ZM11 17.09V19.09L14.5 21L18 19.09V17.09L14.5 19L11 17.09Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccomplishment);
export default __webpack_public_path__ + "static/media/accomplishment.58a7a59a.svg";
export { ForwardRef as ReactComponent };